import { delay, put } from "redux-saga/effects";
import { showCards } from "../../actions/actionCreators";

export default function* delayShowCards(timeout: number) {
  yield delay(timeout);
  yield put(showCards());
}
